import Axios from 'axios'
import { appConfig } from '@src/config'

export { isAxiosError, AxiosError } from 'axios'

const axios = Axios.create({
  baseURL: appConfig.apiUrl,
  timeout: 50000
})

export { Axios, axios }
